import logo from './img/pickle_logo_large.webp';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Kaylea's Pickles
        </p>
      </header>
      <subheader>
        <p>
          An aquired taste.
        </p>
      </subheader>
    </div>
  );
}

export default App;
